import { Image } from "@mantine/core";
import * as ionicons from "ionicons/icons";

// Icons are stored kebab-cased (`arrow-down-circle-outline`), but the package
// exports them camel-cased.
const toExportName = (name) =>
  name.replace(/-([a-z0-9])/g, (_, char) => char.toUpperCase());

// Ionicons ships bare SVGs whose fill and stroke live in the stylesheet of its
// <ion-icon> web component. An <img> loads no stylesheet, so outline variants
// would lose their stroke and paint as solid silhouettes — swap the classes for
// the presentation attributes they stand for.
const CLASS_ATTRIBUTES = {
  ionicon: "stroke='#000'",
  "ionicon ionicon-fill-none": "stroke='#000' fill='none'",
  "ionicon-fill-none ionicon-stroke-width": "fill='none' stroke-width='32'",
  "ionicon-fill-none": "fill='none'",
  "ionicon-stroke-width": "stroke-width='32'",
};

const toDataUri = (icon) => {
  const svg = icon
    .replace(/^data:image\/svg\+xml;utf8,/, "")
    .replace(
      /class='([^']*)'/g,
      (match, className) => CLASS_ATTRIBUTES[className] ?? match
    );

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const Ionicon = ({ name, size = 24, ...props }) => {
  const icon = ionicons[toExportName(name ?? "")];

  if (!icon) {
    return null;
  }

  return (
    <Image src={toDataUri(icon)} w={size} h={size} fit="contain" {...props} />
  );
};
